import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator'
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { room, accessrule } from '../../../../model/room';

export interface IActions {
    loadRooms: () => Promise<Array<room>>,
    selectRoom: (id: string) => any;
    loadRoomDetail: (code: string) => void;
    changeRoomDescription: (text: string, id: string) => void;
    updateRoomDescription: (text: string, id: string) => void;
    changeAccessRule: (accessrule: accessrule) => void;
    changeRoomInEdit: (room: room) => void;
    saveRoom: (room: room) => void;
    createRoom: (room: room) => void;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadRooms: () => {
            return new Promise((res, rej) => dispatch({
                type: Keys.LOADROOMS,
                payload: invokeApi({
                    path: '/api/Rooms',
                    method: 'GET',
                    responseType: 'json'
                }).then(resp => {
                    res(resp)
                    return resp;
                })
            }))
        },
        selectRoom: (id: string) => {
            dispatch({
                type: Keys.SELECTROOM,
                payload: id
            })
        },
        changeRoomInEdit: (room: room) => {
            dispatch({
                type: Keys.CHANGEROOMINEDIT,
                payload: room
            })
        },
        changeRoomDescription: (text: string, id: string) => {
            dispatch({
                type: Keys.CHANGEROOMDESCRIPTION,
                payload: { id, text }
            })
        },
        updateRoomDescription: (text: string, id: string) => {
            dispatch({
                type: Keys.UPDATEROOMDESCRIPTION,
                payload: invokeApi({
                    path: '/api/Rooms/' + id + "/" + text,
                    method: 'POST',
                    responseType: 'json'
                })
            })
        },
        loadRoomDetail: (id: string) => {
            dispatch({
                type: Keys.LOADROOMDETAIL,
                payload: invokeApi({
                    path: '/api/Rooms/' + id,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        changeAccessRule: (accessrule: accessrule) => {
            dispatch({
                type: Keys.CHANGEROOMACCESSRULE,
                payload: { accessrule },
            })
        },
        saveRoom: (room: room) => {
            dispatch({
                type: Keys.SAVEROOM,
                payload: invokeApi({
                    path: '/api/Rooms/' + room._id,
                    method: 'POST',
                    responseType: 'json',
                    body: room,
                })
            })
        },
        createRoom: (room: room) => {
            dispatch({
                type: Keys.CREATEROOM,
                payload: invokeApi({
                    path: '/api/Rooms/',
                    method: 'POST',
                    responseType: 'json',
                    body: room,
                })
            })
        }
    }
}